import { routes } from '~/helpers/routes';
import { RULE_LIBRARY_ORGANIZATION_SLUG } from '~/constants';

export const PRIMARY_RULE_LIBRARY_BASE_URL = 'https://alloy-us.app.alloy.com';
export const PRIMARY_RULE_LIBRARY_CUSTOMER_ID = 49304;

const NON_PROD_HOST_STRINGS = [
  'qaapp',
  'staging',
  'localhost',
  'qa.app',
  'devapp',
];

export const isNonProdRuleLibraryHost = (hostName: string) => (
  NON_PROD_HOST_STRINGS.some(hint => hostName.includes(hint))
);

export const buildRuleLibrarySessionUrl = (
  baseUrl: string,
  customerId: number,
  nextUrl: string,
): string => (
  `${baseUrl}${routes.admin.customers.switchCustomerContext(customerId)}?next_url=${encodeURIComponent(nextUrl)}`
);

type RuleLibraryAccessRecord = {
  organizationNameSlug?: string;
  customerId?: number;
};

type RuleLibraryAccessCollection =
  | RuleLibraryAccessRecord[]
  | Record<string, RuleLibraryAccessRecord>
  | undefined;

export const getRuleLibraryCustomerId = (
  records: RuleLibraryAccessCollection): number | undefined => (
  (Array.isArray(records) ? records : Object.values(records ?? {}))
    .find(record => record.organizationNameSlug === RULE_LIBRARY_ORGANIZATION_SLUG)?.customerId
);
